import { homeNotFoundUi, NotFoundUi } from '@/common/primary/not-found/NotFound.ui';
import { PageVue } from '@/fairplayer/primary/page';
import { PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { FairplayerButtonVue } from '@/common/primary/button';

export default {
  name: 'NotFound',

  components: { PageVue, FairplayerButtonVue },
  props: {
    notFoundUi: {
      type: Object as PropType<NotFoundUi>,
      default: homeNotFoundUi(),
    },
  },

  setup(props: any) {
    const { t } = useI18n();
    const router = useRouter();

    const goTo = () => router.push({ name: props.notFoundUi.routeName });

    return {
      goTo,
      t,
    };
  },
};
